import styled from '@emotion/styled';
import {mixinSubHeading} from 'webapp-lib/styling';

export const Header = styled.div`
  margin-left: var(--gutter);
`;

export const StyledListSection = styled.div`
  border-top: var(--regular-border-width) solid var(--color-core-primary);
  margin: 6px 0 1px 0;
  padding-top: 7px;
  ${mixinSubHeading}
  line-height: 24px;

  :first-of-type {
    margin-top: 0;
  }
`;
